export const actions = {
  startGame: { type: "START_GAME" },
  makeBallDrop: { type: "BALL_DROP" },
  setFloors: { type: "MANAGE_GAME_FLOORS" },
};
